import React from 'react';

// Google Play SVG icon: fills more of the viewBox, no black background
const GooglePlaySvgIcon: React.FC<{ color?: string; size?: number }> = ({
  color = 'currentColor', // Inherit color from parent
  size = 30,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="120 120 720 720"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Google Play"
    style={{ verticalAlign: 'middle', display: 'inline-block' }}
  >
    <path
      d="M629.816 562.299C541.126 473.91 530.44 493.685 632.812 410.289C742.674 488.691 763.349 464.421 629.816 562.299Z"
      fill={color}
    />
    <path
      d="M531.639 463.122C256.782 200.251 271.963 188.066 592.163 384.121C595.06 387.117 606.645 389.614 601.352 394.708C577.981 417.279 555.309 439.951 531.639 463.122Z"
      fill={color}
    />
    <path
      d="M338.578 701.226C398.004 635.209 463.722 573.985 525.345 509.666C530.239 504.672 532.136 504.572 536.83 509.366C558.603 531.438 580.376 553.611 602.149 575.783C536.431 633.71 436.656 681.351 346.868 703.124C343.172 702.225 340.875 701.725 338.578 701.226Z"
      fill={color}
    />
    <path
      d="M310.314 691.039C298.529 701.226 289.141 663.274 291.638 656.881C288.542 629.016 259.877 202.35 317.106 289.441C373.935 347.069 431.163 404.197 488.192 461.626C492.587 469.815 513.56 478.504 505.97 488.093C439.253 554.21 372.736 620.827 310.314 691.039Z"
      fill={color}
    />
  </svg>
);

export default GooglePlaySvgIcon;
